import React, { useEffect, useState } from "react";
import { H2 } from "@/components/ui/typography";
import Chip from "../ui/chip";
import { Link, graphql, useStaticQuery } from "gatsby";
import { kebabCase } from "@/utils";

interface BlogTag {
  tag: string;
}

interface BlogTagResponse {
  allStrapiBlogTag: {
    nodes: BlogTag[];
  };
}

interface BlogHeaderProps extends React.HTMLProps<HTMLButtonElement> {}

const BlogHeader: React.FC<BlogHeaderProps> = () => {
  const data: BlogTagResponse = useStaticQuery(graphql`
    query BlogTags {
      allStrapiBlogTag {
        nodes {
          tag
        }
      }
    }
  `);
  const topics = [{ tag: "All" }, ...data.allStrapiBlogTag.nodes];
  const topicsMap = topics.reduce((a: { [key: string]: BlogTag }, c) => {
    const kebabCasedTag = kebabCase(c.tag);
    a[kebabCasedTag] = c;
    return a;
  }, {});
  const [selectedTopic, setSelectedTopic] = useState("All");

  useEffect(() => {
    let { pathname } = window.location;
    pathname = pathname.replace(/\/blog\/category\/(.*)\/$/g, "$1");
    if (Object.hasOwn(topicsMap, pathname)) {
      setSelectedTopic(topicsMap[pathname].tag);
    }
  }, []);
  return (
    <div className="border-b border-dark py-6 flex flex-col md:flex-row md:justify-between gap-8">
      <H2 className="flex shrink-0 text-dark">All topics</H2>
      <div className="mt-4 md:mt-0 md:flex grow justify-end">
        {topics.map(({ tag }) => (
          <Link
            key={tag}
            to={tag === "All" ? "/blog" : `/blog/category/${kebabCase(tag)}`}
            className="inline-block ml-2 first:ml-0"
          >
            <Chip
              selected={tag === selectedTopic}
              onClick={() => setSelectedTopic(tag)}
              className="last:mr-0"
            >
              {tag}
            </Chip>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BlogHeader;
